import { useParams } from "react-router-dom";
import CityDirectory from "../components/CityDirectory";

/* Generic world city-directory page — /world-cities/:key (japan, malaysia, indonesia,
   south-korea, philippines, china, russia, europe). Title/subtitle/accent come from
   GET /geo/city-directory/:key so new backend directories need zero frontend work. */
export default function WorldCities() {
  const { key } = useParams();
  return (
    <CityDirectory
      key={key}
      id={`world-${key}`}
      endpoint={`/geo/city-directory/${key}`}
      searchPlaceholder="Search a city, country or region…"
    />
  );
}
